import { Menu } from '@mui/icons-material';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { imgSmartNurseLogoText } from 'assets';

import Advertisement from './InputInformation/Advertisement';

export const MAIN_TOP_BAR_HEIGHT = 52;
export const MAIN_SEARCH_BAR_HEIGHT = 52;

interface Props {
  college_ci?: string;
  college_name?: string;
  onMenuClick: () => void;
}

const MainTopBar = ({ college_ci, college_name, onMenuClick }: Props) => {
  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        height: MAIN_TOP_BAR_HEIGHT,
        zIndex: theme => theme.zIndex.drawer + 2,
        borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        backgroundColor: '#fff',
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: `${MAIN_TOP_BAR_HEIGHT}px !important`,
          height: MAIN_TOP_BAR_HEIGHT,
          px: { xs: 0.5, sm: 1 },
          display: 'grid',
          gridTemplateColumns: '48px minmax(0, 1fr) auto',
          alignItems: 'center',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          <IconButton
            edge="start"
            aria-label="menu"
            onClick={onMenuClick}
            sx={{ color: 'text.primary' }}
          >
            <Menu />
          </IconButton>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            minWidth: 0,
            px: 0.5,
          }}
        >
          <Box
            component="img"
            alt={college_name ? college_name : 'SmartNurse'}
            src={college_ci ? college_ci : imgSmartNurseLogoText}
            sx={{
              height: 35,
              maxWidth: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            pr: 0.5,
            minWidth: 0,
            flexShrink: 0,
          }}
        >
          <Advertisement compact />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainTopBar;
